import React, { useEffect, useState } from "react";
import styles from "../ADD/addClient.module.css";
import { get, post } from "../../../../components/api";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ReactSelect } from "../../../../components/ReactSelect";
import { useLocation } from "react-router-dom";
import { SweetAlert } from "../../../../helpers/helper";
import { useNavigate } from "react-router-dom";

const UpdateClient = () => {
  const validationSchema = Yup.object().shape({
    clientName: Yup.string().required("Client Name is required"),
    clientTo: Yup.string(),
    address: Yup.string().required("address is required"),
    phoneNumber: Yup.string()
      .matches(/^\d{10}$/, "Phone Number must be 10 digits")
      .required("Phone Number is required"),
    panNumber: Yup.string().required("PAN Number is required"),
    gstNumber: Yup.string().required("GST Number is required"),
    clientCode: Yup.string(),
    clientType: Yup.string(),
    tag: Yup.string(),
    state: Yup.object()
      .shape({
        _id: Yup.string().required("state selection is required"),
        name: Yup.string().required("state name is required"),
      })
      .required("state is required"),
    pinCode: Yup.string()
      .matches(/^\d{6}$/, "pinCode code must be 6 digits")
      .required("pinCode code is required"),
    Email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
  });

  const location = useLocation();
  const data = location.state.data;
  const navigate = useNavigate();

  const [states, setStates] = useState([]);
  const fetchStates = async () => {
    const response = await get("/states", {});
    if (response.status == 200) {
      let options = response.data.map((data) => {
        return { _id: data._id, name: data.name };
      });
      setStates(options);
    }
  };

  useEffect(() => {
    fetchStates();
  }, []);

  const handleUpdate = async (values, resetForm) => {
    const response = await post("admin/tms/update/clients", {
      clientName: values.clientName,
      email: values.email,
      clientTo: values.clientTo,
      phoneNumber: values.phoneNumber,
      address: values.address,
      panNumber: values.panNumber,
      state: values.state,
      pinCode: values.pinCode,
      gstNumber: values.gstNumber,
      clientCode: values.clientCode,
      tag: values.tag,
      clientType: values.clientType,
    });
    if (response.status == 200) {
      SweetAlert("Client Added Successfully", false);
      resetForm();
      setTimeout(() => {
        navigate("/tms/clients");
      }, 1000);
    } else {
      SweetAlert(response?.message || "error adding client", true);
    }
  };
  return (
    <div className={styles.MainDiv}>
      <div className={styles.HeadDiv}>
        <p className={styles.Heading}>Add Client</p>
      </div>
      <div className={styles.ContentDiv}>
        <Formik
          initialValues={{
            clientName: data?.clientName || "",
            Email: data?.email || "",
            clientTo: data?.clientTo || "",
            phoneNumber: data?.phoneNumber || "",
            address: data?.address || "",
            panNumber: data?.panNumber || "",
            state: data?.state || {},
            pinCode: data?.pinCode || "",
            gstNumber: data?.gstNumber || "",
            clientCode: data?.clientCode || "",
            tag: data?.tag || "",
            clientType: data.clientType || "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm }) => {
            handleUpdate(values, resetForm);
          }}
        >
          {(formik) => {
            const { resetForm } = formik;
            return (
              <Form>
                <div className="row">
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">Client Name</label>
                    <input
                      className="form-control input-field"
                      id="clientName"
                      name="clientName"
                      placeholder="Enter Client Name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.clientName}
                    />
                    {formik.touched.clientName && formik.errors.clientName ? (
                      <div className="field-error ">
                        {formik.errors.clientName}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">Email Id</label>
                    <input
                      className="form-control input-field"
                      id="Email"
                      name="Email"
                      placeholder="Enter Emial Id"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.Email}
                    />
                    {formik.touched.Email && formik.errors.Email ? (
                      <div className="field-error ">{formik.errors.Email}</div>
                    ) : null}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">Client To</label>
                    <input
                      className="form-control input-field"
                      id="clientTo"
                      name="clientTo"
                      placeholder="Enter Destination Type (e.g., Domestic)"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.clientTo}
                    />
                    {formik.touched.clientTo && formik.errors.clientTo ? (
                      <div className="field-error ">
                        {formik.errors.clientTo}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">phoneNumber</label>
                    <input
                      className="form-control input-field"
                      id="phoneNumber"
                      name="phoneNumber"
                      placeholder="Enter Phone Number"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.phoneNumber}
                    />
                    {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                      <div className="field-error ">
                        {formik.errors.phoneNumber}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">address</label>
                    <input
                      className="form-control input-field"
                      id="address"
                      name="address"
                      placeholder="Enter address"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.address}
                    />
                    {formik.touched.address && formik.errors.address ? (
                      <div className="field-error ">
                        {formik.errors.address}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">Pan Number</label>
                    <input
                      className="form-control input-field"
                      id="panNumber"
                      name="panNumber"
                      placeholder="Enter Pan Number"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.panNumber}
                    />
                    {formik.touched.panNumber && formik.errors.panNumber ? (
                      <div className="field-error ">
                        {formik.errors.panNumber}
                      </div>
                    ) : null}
                  </div>

                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">state</label>
                    <ReactSelect
                      name="state"
                      value={formik.values.state}
                      options={states}
                      handleOnChange={(name, value) => {
                        return formik.setFieldValue(name, value);
                      }}
                      isSearchable={true}
                      isLoading={false}
                      noOptionsMessage="state not availables."
                      placeholder="Select state"
                    />
                    {formik.touched.state && formik.errors.state && (
                      <div className="field-error ">{formik.errors.state}</div>
                    )}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">Type</label>
                    <div className="row">
                      {[
                        { value: "consignor", label: "Consignor - Sender" },
                        { value: "customer", label: "Customer - Agent" },
                        { value: "consignee", label: "Consignee - Receiver" },
                        {
                          value: "consignor_consignee",
                          label: "Consignor & Consignee",
                        },
                      ].map((option) => (
                        <div
                          key={option.value}
                          className={`col-md-6 col-lg-6 col-xs-12 ${styles.radioInput}`}
                        >
                          <input
                            type="radio"
                            id={option.value}
                            name="clientType"
                            value={option.value}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            checked={formik.values.clientType === option.value}
                            className={styles.radioInput1}
                          />
                          <label
                            htmlFor={option.value}
                            className={styles.radioLabel}
                          >
                            {option.label}
                          </label>
                        </div>
                      ))}
                    </div>

                    {formik.touched.clientType && formik.errors.clientType ? (
                      <div className="field-error">
                        {formik.errors.clientType}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">pinCode Code</label>
                    <input
                      className="form-control input-field"
                      id="pinCode"
                      name="pinCode"
                      placeholder="Enter pinCode"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.pinCode}
                    />
                    {formik.touched.pinCode && formik.errors.pinCode ? (
                      <div className="field-error ">
                        {formik.errors.pinCode}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">Gst Number</label>
                    <input
                      className="form-control input-field"
                      id="gstNumber"
                      name="gstNumber"
                      placeholder="Enter Gst Number"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.gstNumber}
                    />
                    {formik.touched.gstNumber && formik.errors.gstNumber ? (
                      <div className="field-error ">
                        {formik.errors.gstNumber}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">Client Code</label>
                    <input
                      className="form-control input-field"
                      id="clientCode"
                      name="clientCode"
                      placeholder="Enter Client Code"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.clientCode}
                    />
                    {formik.touched.clientCode && formik.errors.clientCode ? (
                      <div className="field-error ">
                        {formik.errors.clientCode}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">tag</label>
                    <input
                      className="form-control input-field"
                      id="tag"
                      name="tag"
                      placeholder="Enter tag"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.tag}
                    />
                    {formik.touched.tag && formik.errors.tag ? (
                      <div className="field-error ">{formik.errors.tag}</div>
                    ) : null}
                  </div>
                  <div className="col-md-12 col-lg-12 col-xs-12 mb-3">
                    <div className={styles.buttons}>
                      <button
                        type="button"
                        className={styles.CancelButton}
                        onClick={() => resetForm()}
                      >
                        Cancel
                      </button>
                      <button type="submit" className={styles.SubmitButton}>
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default UpdateClient;
